import { render, staticRenderFns } from "./ci_icon.vue?vue&type=template&id=febfd202"
import script from "./ci_icon.vue?vue&type=script&lang=js"
export * from "./ci_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports